/* eslint-disable no-tabs */
import React from 'react';
import PropTypes from 'prop-types';

const CardIcon = ({fill, style, ...rest}) => (
  <svg version="1.1"  xmlns="http://www.w3.org/2000/svg" x="0px"
       y="0px" height="32px" width="32px"
       viewBox="0 0 30.6 22.2" style={{enableBackground:'new 0 0 30.6 22.2'}}>

    <g id="Group_532" transform="translate(-856.172 -335.32)">
	<path id="Path_2992" style={{fill}}
        d="M873.4,351c-0.5,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S873.9,351,873.4,351L873.4,351z"/>
      <path id="Path_2993" style={{fill}} d="M859.9,356.9h23.2c1.6,0,2.9-1.4,2.9-3v-15.1c0-1.6-1.3-2.9-2.9-3h-23.2c-1.6,0-2.9,1.4-2.9,3
		v15.1C857,355.6,858.3,356.9,859.9,356.9L859.9,356.9z M884.1,343.8h-25.1v-2H884L884.1,343.8z M883.1,354.9h-23.2
		c-0.5,0-1-0.5-1-1v-8.1h25.1v8.1C884.1,354.5,883.6,354.9,883.1,354.9L883.1,354.9z M859.9,337.9h23.2c0.5,0,1,0.5,1,1v1h-25.1v-1
		C858.9,338.3,859.3,337.9,859.9,337.9L859.9,337.9z"/>
      <path id="Path_2994" style={{fill}} d="M881.2,351h-3.9c-0.5,0-1,0.4-1,1s0.4,1,1,1l0,0h3.9c0.5,0,1-0.4,1-1S881.7,351,881.2,351
		L881.2,351z"/>
</g>
</svg>

);

CardIcon.propTypes = {
  fill: PropTypes.string,
  style: PropTypes.object,
  rest: PropTypes.object,
};

CardIcon.defaultProps = {
  fill: '#A4ADC1',
  style: {},
  rest: {},
};

export default CardIcon;



// WEBPACK FOOTER //
// ./src/assets/CardIcon.jsx